const cacheSettings = {
  staleTime: 1000 * 60 * 10,
  cacheTime: 1000 * 60 * 10,
}

export default cacheSettings
